import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
// import { deleteCover } from "./../../../redux/slice/policy/policySlice";
import SelectCover from "../../modals/policy/SelectCover";
import { flashMessage as flash } from "../../../utils/flash";
import { useSelector } from "react-redux";

const Cover = ({ p_cover, values, errors, touched, setFieldValue, edit }) => {
  const { cover } = useSelector((state) => state.policy);

  const handleChange = (selected) => {
    if (
      values.cover?.some((item) => parseInt(item.cover) === selected?.value)
    ) {
      flash("error", "Already in the cover list");
      return;
    }
    setFieldValue(`cover`, [...values?.cover, { cover: selected?.value }]);
  };

  const dispatch = useDispatch();

  const DeleteCover = (e, i) => {
    const covers = [...values?.cover];
    if ("id" in covers) return;
    covers.splice(i, 1);
    setFieldValue("cover", covers);
    // dispatch(deleteCover({ id }));
  };

  return (
    <div>
      <h5 className='text-primary-1 mt-1'>POLICY COVER TYPE</h5>

      <div>
        {values?.cover?.map((item, i) => {
          const coverDisplay = cover?.get_covers?.find(
            (cover) => cover.id == item.cover
          );

          return (
            <div
              className='mb-2 shadow-sm p-2 d-flex justify-content-start'
              key={i}
            >
              <b className='me-1'>{i + 1}. </b>
              <div className='d-flex justify-content-between w-100'>
                <span className='text-capitalize'>
                  {coverDisplay?.cover_name}
                </span>
                {edit ? (
                  <span
                    className='ms-3 cursor-p'
                    onClick={(e) => DeleteCover(e, i)}
                  >
                    <FaTrashAlt size={12} className='text-danger' />
                  </span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
      {edit && (
        <div className='col-md-12 mb-3'>
          <div className='col-md-12 mb-3'>
            <button
              type='button'
              className='btn btn-primary btn-sm'
              data-bs-toggle='modal'
              data-bs-target='#select-cover'
            >
              <i className='mdi mdi-plus me-1'></i>
              <span>Add</span>
            </button>
          </div>
        </div>
      )}

      <SelectCover modal_id={"select-cover"} handleChange={handleChange} />
    </div>
  );
};

export default Cover;
